<template>
  <span>
    <b-dropdown variant="none">
      <template #button-content>
        <div class="dropdown-btn">
          <firm-status :status="selectedItem.definition" :alt="selected" :enableBg="true" />
        </div>
      </template>
      <b-dropdown-item v-for="item in options" :key="'status-' + item.definition" @click="itemSelected(item)" :disabled="item.definition == selectedItem.definition">
        <firm-status :status="item.definition" :onlyDot="true" />

        {{ item.name | translate }}
      </b-dropdown-item>
    </b-dropdown>
  </span>
</template>

<script>
import FirmStatus from "@cc/firm-status";
export default {
  components: { FirmStatus },
  props: ["selected"],

  computed: {
    options() {
      const language = this.currentLanguage;
      return [
        {
          definition: "REVIEW",
          name: {
            [language]: this.$t("firm.status.review"),
          },
        },

        // {
        //   definition: "PRE_TEST",
        //   name: {
        //     [language]: this.$t("firm.status.pre-test"),
        //   },
        // },
        {
          definition: "TEST",
          name: {
            [language]: this.$t("firm.status.test"),
          },
        },
        // {
        //   definition: "PRE_PROD",
        //   name: {
        //     [language]: this.$t("firm.status.pre-prod"),
        //   },
        // },

        {
          definition: "PROD",
          name: {
            [language]: this.$t("firm.status.prod"),
          },
        },

        {
          definition: "CANCELED",
          name: {
            [language]: this.$t("firm.status.canceled"),
          },
        },
      ];
    },

    selectedItem() {
      const language = this.currentLanguage;

      return (
        this.options.find((i) => i.definition == this.selected) ?? {
          definition: "REVIEW",
          name: {
            [language]: this.$t("firm.status.review"),
          },
        }
      );
    },
  },
  watch: {
    selected(v) {},
  },
  mounted() {},
  methods: {
    itemSelected(item) {
      this.selected = item.definition;
      if (item) {
        this.$emit("onSelect", item.definition);
      } else {
        this.$emit("onSelect", "REVIEW");
      }
    },
  },
};
</script>

<style>
.multiselect-wrapper .multiselect__option--highlight {
  background: rgb(237, 237, 237) !important;
  color: black !important;
}
.btn-none {
  padding: 0px;
}
</style>
